// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"_1Df62MtDbpQjd46cjOWz91_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-style-loader!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/css-loader?{"sourceMap":true,"autoprefixer":false,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/style-compiler?{"id":"data-v-27e53410","scoped":false,"hasInlineConfig":false}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/Login.vue
// module id = 1022
// module chunks = 1